import React from 'react';
// --- Layout Components ---
// I am importing these based on the example you provided.
// Make sure the paths are correct for your project structure.
import Sidebar from "./Sidebar";
import DashNavbar from "./DashNavbar";
// --- FontAwesome Icons (from your original file) ---
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
// --- CSS Imports ---
// Your original CSS for the contact content
import '../css/ContactUs.css';
// The CSS needed for the .wrapper and .main layout, based on your example
import '../css/dash.css';
// To keep the code clean, we can put your original page content
// into its own component function.
const ContactPageContent = () => {
    return (
        <div className="contact-page">
            {/* Fancy Banner */}
            <div className="contact-banner">
                <div className="banner-overlay">
                    <div className="container">
                    </div>
                </div>
            </div>
            <div className="container contact-container">
                <div className="contact-intro text-center">
                    <h2>Get in Touch</h2>
                    <p>We look forward to hearing from you and helping with any inquiries you may have about our services.</p>
                </div>
                <div className="contact-content-wrapper">
                    {/* Contact Information Card */}
                    <div className="contact-info">
                        <div className="info-card">
                            <h3>Contact Information</h3>
                            <div className="info-item">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="info-icon" />
                                </div>
                                <div className="info-text">
                                    <strong>Address:</strong>
                                    <p>
                                        Punyai Pride, Shivshambho Nagar, Lane 3A, Katraj – Kondhwa Road, Katraj Pune 411046. Maharashtra,
                                        India
                                    </p>
                                </div>
                            </div>
                            <div className="info-item">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faPhone} className="info-icon" />
                                </div>
                                <div className="info-text">
                                    <strong>Phone:</strong>
                                    <p>+91 7447467450 | +91 8600844450</p>
                                </div>
                            </div>
                            <div className="info-item">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                                </div>
                                <div className="info-text">
                                    <strong>Email:</strong>
                                    <p>hr@vetrinahealthcare.com</p>
                                </div>
                            </div>
                            <div className="info-item">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faClock} className="info-icon" />
                                </div>
                                <div className="info-text">
                                    <strong>Office Hours:</strong>
                                    <p>Monday - Saturday: 9:30 AM - 6:00 PM</p>
                                    <p>Sunday: Closed</p>
                                </div>
                            </div>
                            <div className="social-section">
                                <h4>Connect With Us</h4>
                                <div className="social-icons">
                                    <a href="https://www.facebook.com/vetrinahealthcareenglish/" className="social-icon" aria-label="Facebook">
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </a>
                                    <a href="https://x.com/VetrinaPune" className="social-icon" aria-label="Twitter">
                                        <FontAwesomeIcon icon={faTwitter} />
                                    </a>
                                    <a href="https://www.linkedin.com/company/14518974" className="social-icon" aria-label="LinkedIn">
                                        <FontAwesomeIcon icon={faLinkedinIn} />
                                    </a>
                                    <a href="https://www.instagram.com/vetrinahealthcareenglish/" className="social-icon" aria-label="Instagram">
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Map Section */}
                    <div className="map-section">
                        <div className="map-container">
                            <div className="map-header">
                                <h3>Our Location</h3>
                                <p>Visit us at our office</p>
                            </div>
                            <div className="map-wrapper">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d484454.59109815414!2d73.87181400000001!3d18.44732!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2eb0043b86c93%3A0x168070e185711b38!2sKatraj%20kondhawa%20road%20shiv%20shambho%20nagar%20lane%20no%203%20a!5e0!3m2!1sen!2sus!4v1747991997252!5m2!1sen!2sus"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Maps Location of Vetrina Healthcare"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Call to Action Section */}
            <div className="cta-section">
                <div className="container"></div>
            </div>
        </div>
    );
};

// The main component that wraps the content with the dashboard layout
const ContactUs = () => {
    return (
        <>
            <DashNavbar />
            <div className="wrapper">
                <Sidebar />
                <div className="main">
                    {/* We render the original page content here */}
                    <ContactPageContent />
                </div>
            </div>
        </>
    );
};
export default ContactUs;